import { img, readdy } from '@/utils/images';

export const servicePhilosophies = [
  {
    icon: 'ri-leaf-line',
    title: '绿色无忧',
    desc: '倡导自然、温和的健康管理方式，拒绝激进手段，关注长期可持续的体重管理效果。',
    color: 'bg-[#EEF4EC]',
    iconColor: 'text-brand-green',
  },
  {
    icon: 'ri-user-settings-line',
    title: '个性定制',
    desc: '依据每位顾客的体质特征、生活习惯与健康目标，由专业顾问一对一制定专属管理方案。',
    color: 'bg-brand-light',
    iconColor: 'text-brand-brown',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '科学高效',
    desc: '结合现代健康管理科学，制定合理的饮食、运动与生活方式调整计划，科学可量化。',
    color: 'bg-brand-gray',
    iconColor: 'text-brand-deep',
  },
  {
    icon: 'ri-team-line',
    title: '顾问陪伴',
    desc: '专属健康顾问全程跟踪服务，定期回访评估进展，及时调整方案，从不让顾客单独面对困难。',
    color: 'bg-[#FBF5EE]',
    iconColor: 'text-brand-gold',
  },
];

export const targetAudiences = [
  {
    icon: 'ri-scales-3-line',
    title: '体重管理需求',
    desc: '希望科学、健康地控制体重，改善因超重引起的体态问题与生活不适。',
  },
  {
    icon: 'ri-body-scan-line',
    title: '形体塑形目标',
    desc: '追求局部线条优化、体型改善与整体形态提升，注重身体美感与健康并重。',
  },
  {
    icon: 'ri-mental-health-line',
    title: '身心协调发展',
    desc: '希望通过健康管理改善精神状态、提升生活质量，实现身心平衡与自信心建立。',
  },
  {
    icon: 'ri-restart-line',
    title: '产后恢复阶段',
    desc: '处于产后恢复期，需要温和、专业的个性化方案帮助逐步恢复健康状态。',
  },
  {
    icon: 'ri-time-line',
    title: '亚健康人群',
    desc: '长期久坐、饮食不规律，代谢偏低，希望通过系统化管理改善整体健康状况。',
  },
  {
    icon: 'ri-plant-line',
    title: '健康生活方式',
    desc: '具备健康意识，希望建立更科学的生活方式，将健康管理融入日常生活节奏。',
  },
];

export const serviceSteps = [
  {
    step: '01',
    title: '健康评估',
    subtitle: '全面了解个人情况',
    desc: '专业顾问通过面谈问询、体成分分析等方式，全面了解您的身体状况、生活习惯、饮食偏好和健康目标，建立个人健康档案。',
    icon: 'ri-stethoscope-line',
    tags: ['体成分分析', '生活习惯问询', '健康目标确认'],
  },
  {
    step: '02',
    title: '方案定制',
    subtitle: '专属个性化计划',
    desc: '根据评估结果，顾问结合中医经络理论参考与现代健康管理方法，为您制定科学、系统、可执行的个性化健康管理方案。',
    icon: 'ri-file-text-line',
    tags: ['饮食调整建议', '生活方式优化', '周期目标设定'],
  },
  {
    step: '03',
    title: '服务开始',
    subtitle: '专业门店服务体验',
    desc: '在标准化服务环境中，由经过专业培训的顾问团队为您提供系统化的健康管理服务，全程舒适、专业、私密。',
    icon: 'ri-store-2-line',
    tags: ['标准化服务流程', '专业顾问团队', '舒适服务环境'],
  },
  {
    step: '04',
    title: '顾问陪伴',
    subtitle: '全程跟踪与调整',
    desc: '专属健康顾问定期与您沟通，追踪健康数据变化，评估方案执行效果，根据实际情况灵活调整，确保计划持续有效。',
    icon: 'ri-user-heart-line',
    tags: ['定期数据追踪', '方案动态调整', '情绪与动力支持'],
  },
  {
    step: '05',
    title: '周期管理',
    subtitle: '系统化阶段推进',
    desc: '将整体目标分解为可量化的阶段性里程碑，每完成一个周期即进行全面评估与总结，保持清晰的进度感知与成就感。',
    icon: 'ri-calendar-check-line',
    tags: ['阶段里程碑', '进度可视化', '效果评估总结'],
  },
  {
    step: '06',
    title: '长期跟进',
    subtitle: '持续的服务保障',
    desc: '完成核心服务周期后，提供持续性跟进支持，帮助顾客将健康管理习惯融入日常生活，巩固服务成果，避免反弹。',
    icon: 'ri-shield-star-line',
    tags: ['习惯养成指导', '定期回访关怀', '生活方式维护'],
  },
];

export const meridianPoints = [
  {
    title: '经络理论参考',
    desc: '颜轻至服务参考中医经络理论中关于气血运行与脏腑调节的思路，将其作为健康管理方案设计的参考维度，不做独立医疗承诺。',
    icon: 'ri-seedling-line',
  },
  {
    title: '整体健康视角',
    desc: '中医的整体论认为人体各部分相互关联。我们借鉴这一视角，在制定纤体方案时，综合考虑饮食、作息、情绪与体态的整体协调。',
    icon: 'ri-refresh-line',
  },
  {
    title: '温和调理理念',
    desc: '参考"治本"思路，颜轻至倡导循序渐进的健康管理方式，通过调整生活习惯从根本上改善体质，而非追求短期剧变。',
    icon: 'ri-water-flash-line',
  },
  {
    title: '顺应自然节律',
    desc: '结合中医"顺时养生"理念，顾问在制定计划时会综合考虑季节变化、个人作息节律等因素，让方案更贴合个人实际状态。',
    icon: 'ri-sun-line',
  },
];

export const planTypes = [
  {
    name: '基础纤体方案',
    tag: '入门推荐',
    tagColor: 'bg-brand-light text-brand-dark',
    period: '4-8 周',
    desc: '适合初次接触专业健康管理，希望建立良好生活习惯基础，进行初步体重管理的顾客。',
    features: ['初次健康评估建档', '基础个性化饮食建议', '生活方式调整计划', '每周顾问跟进', '阶段数据记录'],
    image: readdy('plan-basic-001'),
  },
  {
    name: '进阶塑形方案',
    tag: '最受欢迎',
    tagColor: 'bg-brand-deep text-white',
    period: '8-16 周',
    desc: '适合有明确形体管理目标，希望通过系统化方案实现局部塑形与整体体态优化的顾客。',
    features: ['深度体成分分析', '个性化综合管理方案', '中医经络理论参考融入', '专属顾问一对一陪伴', '每两周全面评估', '营养与运动协同计划'],
    image: readdy('plan-advanced-001'),
  },
  {
    name: '长期健康管理',
    tag: '长效推荐',
    tagColor: 'bg-brand-light text-brand-dark',
    period: '6+ 个月',
    desc: '适合希望将健康管理作为长期生活方式，建立可持续体重管理习惯并获得持续顾问支持的顾客。',
    features: ['季度健康全面复检', '长期方案动态调整', '习惯养成系统支持', '季节性方案优化', '全年顾问陪伴服务', '家庭健康延伸支持'],
    image: readdy('plan-longterm-001'),
  },
];